import { useState } from 'react';
import { LoginForm } from './components/login';
import { Card } from '../../components/basic/card';
import Logo from '../../assets/images/brand/logo.png';

export const Auth = (props: { isAdminMode: boolean }) => {
  const [step, setStep] = useState({ action: 'login', mode: 'personal', role: 'user', data: {} });
  return (
    <div>
      <img src={Logo} alt="Logo" className="block mx-auto mb-6 mt-16 xl:mt-20" />
      <Card className="mx-auto">
        <LoginForm step={step} setStep={setStep} isAdminMode={props.isAdminMode} />
      </Card>
    </div>
  );
};
